import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';

import deleteStylist from 'actions/stylist/deleteStylist.action';
import LINK from 'constants/link.const';
import { withTranslation } from 'providers/GILT.provider';
import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import getArray from 'utils/accessors/getArray.util';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import fromObjectToQueryString from 'utils/converters/object/fromObjectToQueryString.util';
import { fromPropsToMatchedSalonId } from 'utils/converters/props/bl.util';
import { fromPropsToQuery, fromPropsToQueryString } from 'utils/converters/props/path.util';
import navFor from 'utils/links/navFor.util';
import asObject from 'utils/objects/asObject.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import byId from 'utils/predicates/byId.util';

import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';
import { getFutureAppointmentsWithService } from 'onboarding/services/actions';
import StylistsScreen from 'onboarding/stylists/StylistsScreen';

class StylistsScreenWrap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFooterButtonActive: false,
      timerId: null,
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.currentSalon) {
      navFor('StylistsScreenWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
      return;
    }
    if (!this.props.isFetching && !this.props.isPosting && this.props.stylists.length === 0 && (!this.props.location.state || (this.props.location.state && !this.props.location.state.quick))) {
      navFor('StylistsScreenWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingAddStylist,
        search: fromPropsToQueryString(this.props),
      });
    }
    this.checkFooterButton(this.props);
  }

  componentDidMount() {
    const quickSetupLayout = this.props.location.state && this.props.location.state.quick;
    window.scrollTo(0, 0);

    if (quickSetupLayout) {
      const timerId = setTimeout(() => void this.onFooterButtonClick(), 8000);
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ timerId });
    }
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.checkFooterButton(nextProps);
  }

  onAddMoreClick = () => {
    navFor('StylistsScreenWrap.onAddMoreClick()', this.props).push({
      pathname: LINK.onboardingAddStylist,
      search: fromPropsToQueryString(this.props),
    });
  };

  onDeleteStylist = (stylistId) => {
    const { deleteStylist, currentSalon } = this.props;
    const salonId = currentSalon.id;
    return void deleteStylist({ stylistId, salonId });
  };

  onFooterButtonClick = () => {
    const { location } = this.props;
    const { timerId, isFooterButtonActive } = this.state;
    const quick = asObject(location.state).quick || fromPropsToQuery(this.props).quick === 'true';

    if (!isFooterButtonActive) {
      return;
    }

    if (quick) {
      if (timerId) {
        clearTimeout(timerId);
      }
      const state = { quick: true };

      navFor('StylistsScreenWrap.onFooterButtonClick()', this.props).push({
        pathname: LINK.onboardingServices,
        state,
        search: fromObjectToQueryString({
          ...fromPropsToQuery(this.props),
          ...state,
        }),
      });
    } else {
      navFor('StylistsScreenWrap.onFooterButtonClick()', this.props).push({
        pathname: LINK.onboardingOpeningHours,
        search: fromPropsToQueryString(this.props),
      });
    }
  };

  handleEditStylist = ({ stylistId }) => {
    const { stylists, getFutureAppointmentsWithService } = this.props;
    const stylist = asArray(stylists).find(byId(stylistId));

    if (isFullArray(getArray('role.services', stylist))) {
      const today = moment().startOf('day').toISOString();

      const ids = getArray('role.services', stylist).map(({ id }) => id);

      if (isFullArray(ids)) {
        getFutureAppointmentsWithService(fromPropsToMatchedSalonId(this.props), 0, ids, today);
      }
    }

    navFor('ServicesScreenWrap.render()', 'handleEditStylist()', this.props).push({
      pathname: LINK.onboardingAddStylist,
      state: { stylist },
      search: fromObjectToQueryString({ ...fromPropsToQuery(this.props), stylistId }),
    });
  };

  checkFooterButton = (props) =>
    void this.setState({
      isFooterButtonActive: fromAnyToBool(props.stylists.length > 0 || getAnyOrVoid('location.state.quick', this.props)),
    });

  render() {
    const { isFetching, futureAppointments, location, isPosting, t } = this.props;
    const salonId = fromPropsToMatchedSalonId(this.props);
    const query = fromPropsToQuery(this.props);

    const quickSetupLayout = asObject(location.state).quick || query.quick === 'true';
    const title = quickSetupLayout ? t('register.stylistScreenWrap.title1') : t('register.stylistScreenWrap.title2');
    const description = quickSetupLayout ? t('register.stylistScreenWrap.description1') : t('register.stylistScreenWrap.description2');

    return (
      <div data-bem="StylistsScreenWrap" className="content-wrap">
        <HeaderContainer
          titleFirstPart={title}
          description={description}
          backBtnCallBack={
            quickSetupLayout
              ? null
              : () => {
                  navFor('StylistsScreenWrap.componentWillMount()', this.props).push({
                    pathname: LINK.onboardingServices,
                    search: fromObjectToQueryString(query),
                  });
                }
          }
        />
        <StylistsScreen
          salonId={salonId}
          deleteStylist={this.onDeleteStylist}
          editStylist={this.handleEditStylist}
          onAddMoreClick={this.onAddMoreClick}
          editedStylistsIds={[]}
          settingsSavedStylistsIDs={[]}
          settingsErrorStylistsIDs={[]}
          quickSetupLayout={quickSetupLayout}
          futureAppointments={futureAppointments}
        />
        <OnboardingFooter isFooterButtonActive={this.state.isFooterButtonActive} onButtonClick={this.onFooterButtonClick} isLoading={isFetching || isPosting} />
        {(isPosting || isFetching) && <div data-bem="StylistsScreenWrap__load-blocker" className="load-blocker" />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cognito: state.cognito,
  currentSalon: state.currentSalon,
  ...state.onboarding.stylists,
  isFetching: state.onboarding.stylists.isFetching,
  isPosting: state.onboarding.stylists.isPosting,
  futureAppointments: state.services ? state.services.futureAppointments : [],
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ deleteStylist, getFutureAppointmentsWithService }, dispatch);

const StylistsScreenWrapHoc = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StylistsScreenWrap));

export default StylistsScreenWrapHoc;
